class CrmController {}
CrmController.$inject = [];
export default CrmController;

